var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Iconly/Bulk/Logout"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Logout"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill 1",
    opacity: 0.4,
    d: "M2 6.447C2 3.996 4.03024 2 6.52453 2H11.4856C13.9748 2 16 3.99 16 6.437V17.553C16 20.005 13.9698 22 11.4744 22H6.51537C4.02515 22 2 20.01 2 17.563V16.623V6.447Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 3",
    d: "M21.7789 11.455L18.9331 8.54604C18.639 8.24604 18.1657 8.24604 17.8725 8.54804C17.5803 8.85004 17.5813 9.33704 17.8745 9.63704L19.4337 11.23H17.9387H9.54844C9.13452 11.23 8.79852 11.575 8.79852 12C8.79852 12.426 9.13452 12.77 9.54844 12.77H19.4337L17.8745 14.363C17.5813 14.663 17.5803 15.15 17.8725 15.452C18.0196 15.603 18.2114 15.679 18.4043 15.679C18.5952 15.679 18.787 15.603 18.9331 15.454L21.7789 12.546C21.9201 12.401 22 12.205 22 12C22 11.796 21.9201 11.6 21.7789 11.455Z",
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/Logout.0fa41c89a34c1720d932252783ef44ee.svg";
export { ForwardRef as ReactComponent };